<ion-content>
  <div class="loading-modal-content">
    <div id="pm-loading-modal" class="loading-msg-container">
      <div class="logo"></div>
      <p class="loading-msg">Loading ...</p>
    </div>
  </div>
</ion-content>
